import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


const FRONTEND_BUILD_ID = process.env.REACT_APP_BUILD_ID || "";

let frontendReloadScheduled = false;

async function checkForFrontendUpdate() {
  if (!FRONTEND_BUILD_ID || frontendReloadScheduled) {
    return;
  }

  try {
    const response = await fetch(
      `/build-version.json?t=${Date.now()}`,
      {
        cache: "no-store",
        headers: {
          "Cache-Control": "no-cache"
        }
      }
    );

    if (!response.ok) {
      return;
    }

    const data = await response.json();
    const serverBuildId = String(data?.build_id || "");

    if (
      serverBuildId &&
      serverBuildId !== FRONTEND_BUILD_ID
    ) {
      frontendReloadScheduled = true;
      window.location.reload();
    }
  } catch (_) {
    // Version checks must never interrupt normal application use.
  }
}

window.addEventListener("focus", checkForFrontendUpdate);

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    checkForFrontendUpdate();
  }
});

window.setInterval(checkForFrontendUpdate, 5 * 60 * 1000);

window.setTimeout(checkForFrontendUpdate, 15 * 1000);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
